import React from 'react'
import { TimeTracking as TimeTrackingView } from '@layerfi/components'

import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const TimeTracking = () => {
  return (
    <AccountingLayout>
      <TimeTrackingView />
    </AccountingLayout>
  )
}
